<template>
    <div id="servicess">
        <!-- Main view of services -->
        <mu-col v-if="!display_service">
            <mu-row class="px-0">
                <mu-col :span="12" class="my-5">
                    <h4 class="text-center text-title-services my-5">{{ $t('module_services.header') }}</h4>
                </mu-col>
                <services :images="images_services" :size="3" :time="250" :show_message="false" />
            </mu-row>
            <br>
            <br>
            <br>
            <br>
            <mu-row class="my-3">
                <mu-col :span="12" :sm="6" :md="4" :lg="3" class="px-2 mb-3" v-for="(terminal, index_t) in terminals"
                    :key="index_t">
                    <mu-row class="border-card-services px-0">
                        <mu-col span="12" class="text-center rounded-top px-0 header-card-services">
                            <div class="my-3 px-2">
                                <span class="title_card_services">{{ terminal.name }}</span>
                                <br>
                                <span class="title_card_services">{{ terminal.attention_schedules }}</span>
                            </div>
                        </mu-col>
                        <mu-col span="12" class="text-center px-4" v-for="(service, index_s) in all_services"
                            :key="index_s" v-show="terminal.services.indexOf(service.id) >= 0">
                            <div class="text-card-services my-3 d-flex align-items-center justify-content-center">
                                <box-icon :name='service.icon' :type='service.type' color=' #706f6f'></box-icon>
                                <span class="ml-2">{{ service.name }}</span>
                            </div>
                            <hr v-if="all_services.length - 1 > index_s" class="py-0 my-0" />
                        </mu-col>
                    </mu-row>
                </mu-col>
            </mu-row>
        </mu-col>

        <!-- Specific service view -->
        <mu-col v-else>
            <mu-container id="service" v-html="service_content"></mu-container>
            <mu-row class="center" v-if="this.$route.name == 'shuttle'">
                <mu-col style=" border-radius: 25px;" class="whidthLocation">
                    <mu-col v-for="cards, index_c in station_services" v-bind:key="index_c">
                        <b-card :icon="true" icon_color="#005397" class="my-3 fondo" :title="cards.title"
                            title_align="left" color="rgba(0,0,0,.03)" title_color="black" :expandable="true"
                            :expanded="false">
                            <br>
                            <mu-col v-for="stop, index_sp in cards.stops" v-bind:key="index_sp">

                                <h6 class="pointer" @click="() => {
            stop.show = !stop.show
            locationMaps(stop.center)
        }" style=" margin-left: 1%">
                                    <li class="pointer" style="text-align: left;">
                                        {{ $t(`${stop.name}`) }}</li>
                                </h6>
                                <mu-col v-if="stop.show">
                                    <p style="font-size: 80%;width: 70%;text-align: left;margin-left: 5%;">{{
                                        $t(`${stop.address}`) }}</p>
                                    <a v-if="stop.maps" style="font-size:80%; margin-bottom: 5%;" :href="stop.maps_url">
                                        {{ $t("shuttle.maps") }}</a>
                                </mu-col>

                            </mu-col>
                            <br>
                        </b-card>
                        <hr>
                    </mu-col>
                </mu-col>

                <mu-col style=" border-radius: 25px;" class="whidthLocationR">
                    <div class="col-12 px-0">
                        <gmap-map id="mapa" :center="center" :zoom="zoom" style="width:100%; height: 400px;">
                            <gmap-info-window :options="info_options" :position="info_window_pos"
                                :opened="info_window_open" @closeclick="info_window_open = false">
                                {{ info_content }}
                            </gmap-info-window>
                            <gmap-marker :key="index" v-for="(m, index) in markers" :title="m.position.title"
                                :clickable="true" :position="m.position" @click="toggleInfoWindow(m, index)">
                            </gmap-marker>
                        </gmap-map>
                    </div>
                </mu-col>
            </mu-row>

            <mu-row v-if="this.$route.name == 'livingroom'">
                <mu-container>
                    <mu-row>
                        <mu-col span="12" class="mt-5 text-center">
                            <h2><b>{{ $t('living_room.living_puerto_vallarta') }}</b></h2>
                        </mu-col>
                        <mu-col span="12">
                            <mu-carousel transition="fade" class="slider_terminals">
                                <mu-carousel-item v-for="(image, index) in slider_pv" :key="`slider_pv${index}`"
                                    hide-indicators="true">
                                    <img :src="image" width="100%">
                                </mu-carousel-item>
                            </mu-carousel>
                        </mu-col>
                        <mu-col span="12 px-4" style='text-align: justify;'>
                            <p>{{ $t('living_room.paragraphs.p_1') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_2') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_3') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_4') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_5') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_6') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_7') }}</p>
                            <p>{{ $t('living_room.paragraphs.p_8') }}</p>
                        </mu-col>
                        <mu-col span="12" class="mt-5 text-center">
                            <h2><b>{{ $t('living_room.living_zapopan') }}</b></h2>
                        </mu-col>
                        <mu-col span="12">
                            <mu-carousel transition="fade" class="slider_terminals">
                                <mu-carousel-item v-for="(image, index) in slider_z" :key="`slider_z${index}`"
                                    hide-indicators="true">
                                    <img :src="image" width="100%">
                                </mu-carousel-item>
                            </mu-carousel>
                        </mu-col>
                    </mu-row>
                </mu-container>
            </mu-row>
            <mu-col :span=" 12" class="text-center my-4">
                <mu-button @click="hideService()" to="/servicios" round class="simple px-3" color="#D9D9D9">{{
                    $t('button_action.more_services') }}</mu-button>
            </mu-col>
        </mu-col>
    </div>
</template>


<script>
// HELPERS
import _GlobalHelper from '@/store/helpers/global'
// COMPONENTS
import BCard from '@/components/BCard/Index'
import Services from '@/components/Services/Index'
import SectionBanner from '@/components/SectionBanner/Index'
// VUEX
import { mapMutations, mapGetters } from 'vuex'
//JSON's
const servicesTabData = require('~/assets/json/services.json')
const serviceData = require('~/assets/json/services.data.json')

const servicesTabData_en = require('~/assets/json/en-services.json')
const serviceData_en = require('~/assets/json/en-services.data.json')
//IMAGES
import slider_pv_01 from '@@/images/travel_services/slider_pv/sala_viajero_pv01.jpg'
import slider_pv_02 from '@@/images/travel_services/slider_pv/sala_viajero_pv02.jpg'
import slider_pv_03 from '@@/images/travel_services/slider_pv/sala_viajero_pv03.jpg'
import slider_pv_04 from '@@/images/travel_services/slider_pv/sala_viajero_pv04.jpg'
import slider_pv_05 from '@@/images/travel_services/slider_pv/sala_viajero_pv05.jpg'

import slider_z_01 from '@@/images/travel_services/slider_z/sala_viajero_z01.jpg'
import slider_z_02 from '@@/images/travel_services/slider_z/sala_viajero_z02.jpg'
import slider_z_03 from '@@/images/travel_services/slider_z/sala_viajero_z03.jpg'
import slider_z_04 from '@@/images/travel_services/slider_z/sala_viajero_z04.jpg'
import slider_z_05 from '@@/images/travel_services/slider_z/sala_viajero_z05.jpg'

export default {
    components: {
        'b-card': BCard,
        Services: Services,
        SectionBanner: SectionBanner
    },
    data() {
        return {
            images_services: servicesTabData.SERVICES,
            terminals: servicesTabData.STATIONS,
            all_services: servicesTabData.STATION_SERVICES,
            station_services: servicesTabData.STATION_SHUTTLE,
            display_service: false,
            service_content: '',
            info_window_pos: null,
            lat: 0,
            lng: 0,
            terminas: true,
            info_window_open: false,
            info_content: '',
            current_midx: null,
            map_center: null,
            zoom: 15,
            info_options: {
                pixel_offset: {
                    width: 0,
                    height: -35
                }
            },
            //20.512365, -103.366087
            center: { lat: 20.7020306, lng: -103.4597825 },
            markers: [
                {   //Tlaquepaque-Central Nueva Modulos
                    position: { lat: 20.6209522, lng: -103.2873225, title: "Central Nueva Modulos" },
                    info_text: ' Nueva Central Camionera, Tlaquepaque, Jalisco, C.P. 45580'
                },
                {   //Tlaquepaque-Terminal Vallarta Plus
                    position: { lat: 20.62684, lng: -103.288822, title: "Tlaquepaque" },
                    info_text: 'Autopista a Zapotlanejo #210 Tlaquepaque, Jalisco, C.P. 45580'
                },
                {   //Zapopan-Estación Central de Autobuses
                    position: { lat: 20.6231284, lng: -103.2849865, title: "Línea 3 Estación Central de Autobuses" },
                    info_text: 'Av. de las Torres 4831, Nueva Central Camionera, San Pedro Tlaquepaque,Jal C.P. 45580'
                },
                {   //Zapopan-Terminal Vallarta Plus
                    position: { lat: 20.7020306, lng: -103.4597825, title: "Terminal Zapopan Vallarta Plus" },
                    info_text: 'Prol. Av. Vallarta #650-B, Col. San Juan de Ocotán, Zapopan, Jal. C.P.45019.'
                },
                {   //Zapopan-Macrobus Periferico Vallarta
                    position: { lat: 20.6964444, lng: -103.4546389, title: "Macrobús Periferico Vallarta (Solo Bajada)" },
                    info_text: 'Desde la ruta de Terminal de Vallarta Plus hasta la Minerva te dejamos en algunas paradas establecidas, como en el Macrobús Periférico Estación Vallarta'
                },
                {   //Zapopan-La Gran Plaza
                    position: { lat: 20.67499, lng: -103.4062268, title: "La Gran Plaza  (Solo Bajada)" },
                    info_text: 'Desde la ruta de Terminal de Vallarta Plus hasta la Minerva te dejamos en algunas paradas establecidas, como en La Gran Plaza'
                },
                {   //Zapopan-Plaza Galerias
                    position: { lat: 20.6810556, lng: -103.4321944, title: "Plaza Galerías (Solo Bajada)" },
                    info_text: 'Desde la ruta de Terminal de Vallarta Plus hasta la Minerva te dejamos en algunas paradas establecidas, como en La Gran Plaza'
                },
                {   //Zapopan-Vallarta Plus Minerva
                    position: { lat: 20.673977, lng: -103.3867915, title: "Vallarta Plus Minerva" },
                    info_text: 'Te dejamos en nuestra oficina de venta de Boletos Vallarta Plus Minerva para tu comodidad'
                },
                {   //Zapopan-Nuevo Consulado Americano
                    position: { lat: 20.6849974, lng: -103.3970317, title: "Terminal Zapopan - Nuevo Consulado Americano (Nuevo)" },
                    info_text: 'Desde la ruta de Terminal de Vallarta Plus hasta la Minerva te dejamos en algunas paradas establecidas, como en el Nuevo Consulado Americano'
                },
                {   //Zapopan-Terminal Vallarta Plus
                    position: { lat: 20.7020306, lng: -103.4597825, title: "Terminal Zapopan Vallarta Plus" },
                    info_text: 'Prol. Av. Vallarta #650-B, Col. San Juan de Ocotán, Zapopan, Jal. C.P.45019'
                },
                {   //Zapopan-Estación Mercado del Mar
                    position: { lat: 20.7288, lng: -103.38923, title: "Línea 3 Mercado del Mar" },
                    info_text: 'Av. Juan Pablo II 92, Zapopan Centro, Zapopan, Jal. C.P. 45150.'
                },
                {   //Zapopan-CUCEA
                    position: { lat: 20.7399743, lng: -103.3813799, title: "CUCEA" },
                    info_text: 'Periférico Norte N° 799, Núcleo Universitario Los Belenes, Zapopan, Jal. C.P. 45100.'
                },
                {   //Zapopan-Plaza Patria
                    position: { lat: 20.71266, lng: -103.37819, title: "Plaza Patria" },
                    info_text: 'Av. Patria 1950, Plaza Patria, Guadalajara, Jal. C.P. 45170.'
                }
            ],
            slider_pv: [slider_pv_01, slider_pv_02, slider_pv_03, slider_pv_04, slider_pv_05],
            slider_z: [slider_z_01, slider_z_02, slider_z_03, slider_z_04, slider_z_05]
        }
    },
    computed: {
        ...mapGetters({
            lang: _GlobalHelper.getters.language
        }),
        loading: {
            set(data) {
                this.set_loading(data)
            },
            get() {
            }
        }
    },
    watch: {
        lang() {
            this.lang == 'es' ?
                (this.images_services = servicesTabData.SERVICES,
                    this.terminals = servicesTabData.STATIONS,
                    this.all_services = servicesTabData.STATION_SERVICES,
                    this.station_services = servicesTabData.STATION_SHUTTLE) :
                (this.images_services = servicesTabData_en.SERVICES,
                    this.terminals = servicesTabData_en.STATIONS,
                    this.all_services = servicesTabData_en.STATION_SERVICES,
                    this.station_services = servicesTabData_en.STATION_SHUTTLE)
        }
    },
    methods: {
        locationMaps(center) {
            this.center = center
        },
        ...mapMutations({
            set_loading: _GlobalHelper.mutations.loading
        }),

        hideService() {
            this.service_content = ''
            this.display_service = false
            this.loading = { show: false, message: null }
        }
    },
    created() {
        this.lang == 'es' ?
            (this.images_services = servicesTabData.SERVICES,
                this.terminals = servicesTabData.STATIONS,
                this.all_services = servicesTabData.STATION_SERVICES,
                this.station_services = servicesTabData.STATION_SHUTTLE) :
            (this.images_services = servicesTabData_en.SERVICES,
                this.terminals = servicesTabData_en.STATIONS,
                this.all_services = servicesTabData_en.STATION_SERVICES,
                this.station_services = servicesTabData_en.STATION_SHUTTLE)
        this.loading = { show: true, message: `<h5>${this.$i18n.t('loading.global')}</h5>`, timeout_active: true }

        if (this.$route.name != "services" && this.$route.name != "servicios") {
            this.lang == 'es' ? (this.service_content = serviceData[this.$route.name]) : (this.service_content = serviceData_en[this.$route.name])
            this.display_service = true
        }
    },
    updated() {
        this.lang == 'es' ? (this.service_content = serviceData[this.$route.name]) : (this.service_content = serviceData_en[this.$route.name])

        if (this.$route.name === "services") {
            this.display_service = false
            this.loading = { show: false, message: null }
        }
    }
}
</script>


<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

.text-title-services {
    font-family: "Inter", sans-serif;
    font-size: 32px;
    color: #000000;
    font-weight: 600;

}

.header-card-services {
    background: #005397;
}

.border-card-services {
    border: 3px solid #005397 !important;
    border-radius: 14px !important;
}

.title_card_services {
    color: white;
    font-family: "Inter", sans-serif;
    font-size: 20px;
    font-weight: 700;
}

.text-card-services {
    color: #706f6f;
    font-family: 'sans-serif';
}

center {
    display: flex;
    justify-content: center;
}

#servicess {
    .whidthLocation {
        margin-left: 20%;
        margin-right: 1%;
    }

    .whidthLocationR {
        margin-right: 20%;
    }

    .mu-divider {
        background-color: #706f6f !important;
    }

    .mu-item {
        color: #706f6f;
        -ms-flex-pack: center !important;
        justify-content: center !important;
        font-size: 1em;
    }

    .simple :hover {
        color: white !important;
    }

    .servicios {
        color: tomato;
        font-family: 'sans-serif';
    }

    .fondo {
        background-color: white;
        color: black;
    }

    .color {
        color: black;
    }

    .margin {
        margin: 10px;
    }

    #service {
        .section-container-text {
            position: relative;
            padding-left: auto;
            padding-right: auto;
            text-align: justify;
            font-size: 1rem;
            color: #292b2c;

            h2 {
                margin-bottom: 1.5em !important;
                text-align: center !important;
                color: #0033A1;
            }

            h4 {
                margin-bottom: 1em !important;
                color: #0033A1;
            }

            img,
            p,
            ul {
                margin-bottom: 1.5em !important;
            }

            b {
                font-size: 1.1rem;
                color: black;
            }

        }
    }
}

.slider_terminals {
    width: 100%;
}

@media(min-width: 1700px) {
    .slider_terminals {
        width: 100%;
        height: 640px;
    }
}

@media(max-width: 1700px) {
    .slider_terminals {
        width: 100%;
        height: 530px;
    }
}

@media(max-width: 1200px) {
    .slider_terminals {
        width: 100%;
        height: 450px;
    }
}

@media(max-width: 992px) {
    .slider_terminals {
        width: 100%;
        height: 375px;
    }
}

@media(max-width: 768px) {
    .slider_terminals {
        width: 100%;
        height: 250px;
    }
}

@media(max-width: 576px) {
    .slider_terminals {
        width: 100%;
        height: 250px;
    }
}
</style>
